import React, { useState, useEffect, useRef, useCallback } from "react";
import { Row, Col } from "react-bootstrap";
import { Reorder, LayoutGroup } from "framer-motion";
import DashMedidasSortableSection from "../DashMedidasSortableSection/DashMedidasSortableSection";
import { DashMedidasSectionOrderProvider } from "../../context/DashMedidasSectionOrderContext";
import { sanitizeVisibleOrder } from "../../hooks/useDashMedidasSectionOrder";

const DashMedidasSectionsList = ({
  order: externalOrder,
  onOrderCommit,
  sectionContent,
}) => {
  const [order, setOrder] = useState(() =>
    sanitizeVisibleOrder(externalOrder, externalOrder)
  );
  const isDraggingRef = useRef(false);
  const orderRef = useRef(order);
  const externalOrderRef = useRef(externalOrder);

  orderRef.current = order;
  externalOrderRef.current = externalOrder;

  useEffect(() => {
    if (isDraggingRef.current) return;
    setOrder((prev) => sanitizeVisibleOrder(externalOrder, prev));
  }, [externalOrder]);

  const handleReorder = useCallback((newOrder) => {
    setOrder((prev) => sanitizeVisibleOrder(newOrder, prev));
  }, []);

  const handleDragStart = useCallback(() => {
    isDraggingRef.current = true;
  }, []);

  const handleDragEnd = useCallback(() => {
    isDraggingRef.current = false;

    const finalOrder = sanitizeVisibleOrder(
      orderRef.current,
      externalOrderRef.current
    );

    setOrder(finalOrder);
    onOrderCommit(finalOrder);
  }, [onOrderCommit]);

  return (
    <DashMedidasSectionOrderProvider sortableSectionIds={order}>
      <LayoutGroup id="dash-medidas-sections">
        <Reorder.Group
          axis="y"
          values={order}
          onReorder={handleReorder}
          className="dash-medidas-sections-reorder"
        >
          {order.map((sectionId) => (
            <DashMedidasSortableSection
              key={sectionId}
              sectionId={sectionId}
              className="dash-medidas-section-row"
              onDragStart={handleDragStart}
              onDragEnd={handleDragEnd}
            >
              <Row className="m-0 g-0">
                <Col
                  xs={12}
                  className={`p-0${
                    sectionId === "dash-graficos" ? " dash-graficos-col" : ""
                  }`}
                >
                  {sectionContent[sectionId]}
                </Col>
              </Row>
            </DashMedidasSortableSection>
          ))}
        </Reorder.Group>
      </LayoutGroup>
    </DashMedidasSectionOrderProvider>
  );
};

export default DashMedidasSectionsList;
